const translations = {
  en: {
    // IntroScreen
    startSurvey: 'Start Survey',
    welcome: 'Welcome',
    questions: 'questions',
    question: 'question',
    aboutMinutes: 'About {minutes} min',

    // Navigation
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    saving: 'Saving...',
    pageOf: 'Page {current} of {total}',

    // MultiSelectQuestion
    selectedOf: '{count} of {max} selected',

    // CompletionScreen
    thankYou: 'Thank you',
    responseRecorded: 'Your response has been recorded. We appreciate you taking the time to share your thoughts.',
    previewComplete: 'This is the completion screen respondents will see. No data was saved.',

    // ErrorScreen
    linkExpired: 'Link Expired',
    linkExpiredMessage: 'This survey link has expired.',
    invalidLink: 'Invalid Link',
    invalidLinkMessage: 'This survey link is not valid.',
    pleaseWait: 'Please Wait',
    pleaseWaitMessage: 'Please wait a moment before trying again.',
    alreadyCompleted: 'Already Completed',
    alreadyCompletedMessage: 'You have already completed this survey.',
    connectionError: 'Connection Error',
    connectionErrorMessage: 'Unable to connect. Please check your internet connection.',
    tryAgain: 'Try Again',

    // LoadingScreen
    loadingSurvey: 'Loading survey...',

    // Language toggle
    toggleLanguage: 'ES',
  },
  es: {
    startSurvey: 'Comenzar Encuesta',
    welcome: 'Bienvenido',
    questions: 'preguntas',
    question: 'pregunta',
    aboutMinutes: 'Aproximadamente {minutes} min',

    back: 'Volver',
    next: 'Siguiente',
    submit: 'Enviar',
    saving: 'Guardando...',
    pageOf: 'Pagina {current} de {total}',

    selectedOf: '{count} de {max} seleccionados',

    thankYou: 'Gracias',
    responseRecorded: 'Su respuesta ha sido registrada. Agradecemos que se haya tomado el tiempo de compartir sus opiniones.',
    previewComplete: 'Esta es la pantalla de finalizacion que veran los encuestados. No se guardaron datos.',

    linkExpired: 'Enlace Expirado',
    linkExpiredMessage: 'Este enlace de encuesta ha expirado.',
    invalidLink: 'Enlace No Valido',
    invalidLinkMessage: 'Este enlace de encuesta no es valido.',
    pleaseWait: 'Por Favor Espere',
    pleaseWaitMessage: 'Por favor espere un momento antes de intentar de nuevo.',
    alreadyCompleted: 'Ya Completada',
    alreadyCompletedMessage: 'Ya ha completado esta encuesta.',
    connectionError: 'Error de Conexion',
    connectionErrorMessage: 'No se puede conectar. Por favor verifique su conexion a internet.',
    tryAgain: 'Intentar de Nuevo',

    loadingSurvey: 'Cargando encuesta...',

    toggleLanguage: 'EN',
  },
};

/**
 * Get translated string with variable interpolation.
 * Usage: t('es', 'aboutMinutes', { minutes: 5 }) => "Aproximadamente 5 min"
 */
export function t(lang, key, vars = {}) {
  const str = translations[lang]?.[key] || translations.en[key] || key;
  return Object.entries(vars).reduce(
    (result, [varName, value]) => result.replace(`{${varName}}`, value),
    str
  );
}

export default translations;
